/*
 * @author          Riddhi D Parekh
 * @date            21th November 2018
 * @type            Survey store File
 * @description -   This file has methods to retrieve and save order of all questions of a survey
 *
 */
function initialState () {
  return {
    // surveyQuestions: [],
    relationships: {},
    surveySettings: [],
    query: {},
    cancelSource: null,
    loading: false,
    shareTemplate: {},
    emailSent: 0
    // calledBefore: false
  }
}
const getters = {
  // surveyQuestions: state => {
  //   let rows = state.surveyQuestions
  //   return rows
  // },
  surveySettings: state => {
    let rows = state.surveySettings
    return rows
  },
  // calledBefore: state => state.calledBefore,
  total: state => state.length,
  loading: state => state.loading,
  emailSent: state => state.emailSent,
  relationships: state => state.relationships,
  shareTemplate: state => state.shareTemplate
}
const actions = {
  // // get data for edit question
  // async getSurveyData ({ commit, state }, surveyData) {
  //   if (surveyData.in_survey_Id) {
  //     commit('setLoading', true)
  //     axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
  //     let url = process.env.API_PATH + '/getAllSurveyQuestionBySurveyId';
  //     await axios
  //       .post(
  //         url,
  //         {
  //           lang: surveyData['lang'],
  //           request_id: surveyData['requestId'],
  //           in_survey_Id: surveyData['in_survey_Id']
  //         },
  //         {
  //           headers: { 'Content-Type': 'application/json' }
  //         }
  //       )
  //       .then(response => {
  //         if (response.data.flag) {
  //           commit('setsurveyQuestions', response.data.data)
  //         } else {
  //         }
  //       })
  //       .catch(error => {})
  //       .finally(() => {
  //         commit('setLoading', false)
  //       })
  //   }
  // },

  // set settings for survey
  async setSurveySettings ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/addSurveySettings';
      await axios
        .post(url, {
          lang: surveyData['lang'],
          request_id: surveyData['requestId'],
          in_survey_Id: surveyData['in_survey_Id'],
          in_survey_type_id: surveyData['in_survey_type_id'],
          in_response_setting: surveyData['in_response_setting'],
          in_access_setting: surveyData['in_access_setting']
        })
        .then(response => {
          if (response.data.flag) {
            commit('setSurveySettings', response.data.data)
          } else {
          }
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },

  // get settings for survey
  async getSurveySettings ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getSurveySettings';
      await axios
        .post(url, {
          lang: surveyData['lang'],
          request_id: surveyData['requestId'],
          in_survey_Id: surveyData['in_survey_Id']
        })
        .then(response => {
          if (response.data.flag) {
            commit('setSurveySettings', response.data.data)
          } else {
          }
        })
        .catch(error => {})
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // get default share template
  async getShareTemplate ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/getDefaultShareTemplate';
      await axios
        .post(url, {
          lang: surveyData['lang'],
          request_id: surveyData['requestId'],
          base_url: surveyData['baseUrl'],
          in_survey_Id: surveyData['in_survey_Id']
        })
        .then(response => {
          if (response.data.flag) {
            commit('setShareTemplate', response.data)
          }
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  // save share survey mail data and send mail
  async saveSendMail ({ commit, state }, surveyData) {
    if (surveyData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = surveyData['jwt_token']
      let url = process.env.API_PATH + '/sendMail';
      await axios
        .post(url, {
          lang: surveyData['lang'],
          request_id: surveyData['requestId'],
          in_survey_Id: surveyData['in_survey_Id'],
          in_notification_id: surveyData['in_notification_id'],
          emailArray: surveyData['emailsArray'],
          emailccArray: surveyData['emailsccArray'],
          emailbccArray: surveyData['emailsbccArray'],
          email_message: surveyData['st_email_message_code'],
          subject: surveyData['st_notification_subject'],
          user_mail: surveyData['user_mail'],
          company_details: surveyData['company_details']
        })
        .then(response => {
          if (response.data.flag) {
            commit('setEmailSent', true)
          } else {
            commit('setEmailSent', false)
          }
        })
        .finally(() => {
          commit('setLoading', false)
        })
    }
  },
  setQuery ({ commit }, value) {
    commit('setQuery', purify(value))
  },
  resetState ({ commit }) {
    commit('resetState')
  }
}
const mutations = {
  // setsurveyQuestions (state, items) {
  //   state.surveyQuestions = items
  //   console.log('here is d data')
  //   console.log(state.surveyQuestions)
  //   state.calledBefore = true
  // },
  setSurveySettings (state, items) {
    items.forEach((value, key) => {
      // Checkbox v-model (no true-value) checks via looseEqual(model, true), which
      // is false for the number 1 - must assign real booleans or the checkbox
      // renders unchecked even though the value is truthy everywhere else.
      value.in_access_setting_int = value.in_access_setting == 1 || value.in_access_setting == 3
      value.in_access_setting_ext = value.in_access_setting == 2 || value.in_access_setting == 3
    })
    state.surveySettings = items
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setEmailSent (state, emailSent) {
    state.emailSent = emailSent
  },
  setQuery (state, query) {
    state.query = query
  },
  setCancelSource (state) {
    state.cancelSource = axios.CancelToken.source()
  },
  resetState (state) {
    state = Object.assign(state, initialState())
  },
  setShareTemplate (state, items) {
    state.shareTemplate = items
  }
}
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}
